import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-logoEnterprise",
  "use": "icon-logoEnterprise-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"icon-logoEnterprise\"><path d=\"M22,21h-1.5v-9.5c0-0.3-0.2-0.6-0.4-0.8L13.5,6V2c0-0.4-0.2-0.7-0.5-0.9S12.3,1,12,1.2l-7,5C4.7,6.4,4.5,6.7,4.5,7v14H2\n\tc-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h3.5h7H22c0.6,0,1-0.4,1-1C23,21.4,22.6,21,22,21z M11.5,21h-5V7.5l5-3.6V21z M18.5,21h-5V8.4\n\tl5,3.6V21z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol